import { ECanProduct } from "../../Model";
import { EImagerType } from "../../Model/EImagerType";
import { EInstrumentType } from "../../Model/EInstrumentType";
import { EIntegrationConnectionType } from "../../Model/EIntegrationConnectionType";
import { EDatabaseType } from "../../Model/EDatabaseType";
import { ETemperatureControlType } from "../../Model/ETemperatureControlType";
import {
  EFetchInitialConfigAction,
  FetchInitialConfigAction,
} from "../actions/InitialConfigurationAction";
import { FetchStatus } from "./../../Model/FetchStatus";
import {
  NeedInitialConfiguration,
  SuiteInitialConfiguration,
} from "./../../Model/InitialConfiguration";
import { RootState } from "./RootReducer";

type State = {
  status: FetchStatus;
  isNeedInitialConfig: NeedInitialConfiguration;
  suite: SuiteInitialConfiguration;
};

const initialState: State = {
  isNeedInitialConfig: {
    isNeedInitialConfiguration: false,
  },
  suite: {
    brokerUrl: "",
    databaseType: EDatabaseType.Unknown,
    suiteDatabase: {
      serverName: "",
      databaseName: "",
      userID: "",
      password: "",
      useWindowsAuthentication: false,
      checkVersion: false,
      maxPoolSize: 0,
    },
    limsInstrumentId: 0,
    instrumentId: "",
    instrumentName: "",
    instrumentType: EInstrumentType.Unknown,
    imagerType: EImagerType.Unknown,
    canProductType: ECanProduct.UNKNOWN,
    temperatureControlType: ETemperatureControlType.Unknown,
    listenUrl: "",
    connectionType: EIntegrationConnectionType.FormulatrixIntegrationService,
    restApi:{
        apiUrl: "",
        integrationUrl: "",
        apiVersion: "",
        username: "",
        password: "",
        useLog: false,
        timeOutInSeconds: 0,
    },
  },
  status: {
    pending: false,
    completed: false,
    error: null,
  },
};

export function initialConfigReducer(
  state = initialState,
  action: FetchInitialConfigAction
): State {
  switch (action.type) {
    case EFetchInitialConfigAction.FETCH_INITIAL_CONFIG_PENDING:
      return initialState;
    case EFetchInitialConfigAction.FETCH_INITIAL_CONFIG_SUCCESS:
      if (action.needInitialConfiguration == null) {
        throw new Error("need initial configuration is null");
      }
      return {
        isNeedInitialConfig: action.needInitialConfiguration,
        suite: action.suite!,
        status: {
          pending: false,
          completed: true,
          error: null,
        },
      };
    case EFetchInitialConfigAction.FETCH_INITIAL_CONFIG_ERROR:
      return {
        ...initialState,
        status: {
          pending: false,
          completed: true,
          error: action.error,
        },
      };
    default:
      return state;
  }
}

export const getSuiteConfiguration = (
  state: RootState
): SuiteInitialConfiguration => state.initialConfiguration.suite!;

export const getIsInitialConfigurationNeeded = (
  state: RootState
): NeedInitialConfiguration => state.initialConfiguration.isNeedInitialConfig;

export const getIsInitialConfigurationNeededFetchStatus = (
  state: RootState
): FetchStatus => state.initialConfiguration.status;
